import { GQLRichTextBlock } from "graphql/generated-types";

const RichText = ({ block }: { block: GQLRichTextBlock }) => {
	return (
		<div className="prose lg:text-18px max-w-none antialiased" dangerouslySetInnerHTML={{ __html: block.value }} />
	);
};

export default RichText;
